import { Tooltip, Typography } from '@mui/material';

// Values injected at build time (see vite.config.ts `define`).
const version = __APP_VERSION__;
const gitSha = __GIT_SHA__;
const buildDate = __BUILD_DATE__;

function formatBuildDate(iso: string): string {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  // Date only for the compact label; the tooltip carries the full timestamp.
  return parsed.toISOString().slice(0, 10);
}

interface BuildInfoProps {
  /** When collapsed, show only the short SHA to fit the narrow rail. */
  collapsed?: boolean;
}

export function BuildInfo({ collapsed = false }: BuildInfoProps) {
  const shortDate = formatBuildDate(buildDate);
  const compactLabel = collapsed ? gitSha : `v${version} · ${shortDate} · ${gitSha}`;
  const tooltip = `Version ${version}\nBuilt ${buildDate}\nCommit ${gitSha}`;

  return (
    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>} placement="top">
      <Typography
        component="div"
        aria-label={`Build ${version}, ${buildDate}, commit ${gitSha}`}
        sx={{
          px: collapsed ? 0 : 1.25,
          pb: 0.5,
          fontSize: 11,
          lineHeight: 1.4,
          textAlign: 'center',
          color: 'rgba(255,255,255,0.55)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          userSelect: 'text',
        }}
      >
        {compactLabel}
      </Typography>
    </Tooltip>
  );
}
